module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Ideal-bac1724bb1ac599570cb6769f66a3919.svg";